<template>
	<div id="head_index">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<div class="d-flex jc-center hm_titbg">
					<div :class="tit_class">{{ title }}</div>
					<dv-decoration-10 :color="['#00ffff', '#0090ff']"
						style="width:3.3rem;height:1px;position: absolute;left:18%;top: 0.35rem" />
					<dv-decoration-10 :reverse="true" :color="['#00ffff', '#0090ff']"
						style="width:2.5rem;height:1px;position: absolute;right:19%;top: 0.35rem" />
					<!-- 时间和天气 -->
					<div class="time_weather">
						<div class="float-r">{{ date }}</div>
					</div>
					<!-- 时间和天气结束 -->
					<!-- 全屏 -->
					<div class="full_btn" v-on:click="screen()"><img width="100%" src="../../assets/img/full_icon.png">
					</div>
				</div>
				<div class="body-box">
					<!-- 3小块数据 -->
					<div class="w-100 d-flex flex-nowrap flex-between">
						<div class="top_block">
							<dv-border-box-7 :color="['#085f6a', '#085f6a']">
								<top1 />
							</dv-border-box-7>
						</div>
						<div class="top_block">
							<dv-border-box-7 :color="['#085f6a', '#085f6a']">
								<top2 />
							</dv-border-box-7>
						</div>
						<div class="top_block">
							<dv-border-box-7 :color="['#085f6a', '#085f6a']">
								<top3 />
							</dv-border-box-7>
						</div>
					</div>
					<!-- 3小块数据结束 -->
					<!-- 中间开始 -->
					<div class="main_grid">
						<!-- 第一列 -->
						<div class="left_block">
							<dv-border-box-7 :color="['#085f6a', '#085f6a']">
								<left />
							</dv-border-box-7>
						</div>
						<!-- 第一列结束 -->
						<!-- 第二列 -->
						<div class="center_block">
							<dv-border-box-7 :color="['#085f6a', '#085f6a']">
								<center1 />
							</dv-border-box-7>
						</div>
						<!-- 第二列结束 -->
						<!-- 第三列开始 -->
						<div class="right_block">
							<dv-border-box-7 :color="['#085f6a', '#085f6a']">
								<right />
							</dv-border-box-7>
						</div>
						<!-- 第三列结束 -->
					</div>
					<!-- 中间结束 -->
					<div class="w-100 bottom_block">
						<dv-border-box-7 :color="['#085f6a', '#085f6a']">
							<bottom />
						</dv-border-box-7>
					</div>
					<!-- 下半部分结束 -->
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
import { sendWebsocket1, closeWebsocket1 } from '@/common/websocket1.js';
import { sendWebsocket2, closeWebsocket2 } from '@/common/websocket2.js';
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var source = storage.getItem("source");
var schoolName = storage.getItem("schoolName");
var title = storage.getItem("title");
if (title == 'false') {
	title = schoolName + '校长大数据看板';
}
import left from "./left";
import right from "./right";
import top1 from "./top1";
import top2 from "./top2";
import top3 from "./top3";
import center1 from "./center";
import bottom from "./bottom";
export default {
	data() {
		return {
			loading: true,
			tit_class: '',
			title: title,
			date: this.dateFormatToString(new Date()),
			fullscreen: false
		};
	},
	components: {
		left,
		right,
		top1,
		top2,
		top3,
		center1,
		bottom
	},
	mounted() {
		this.cancelLoading();
		this.initData();
		this.requstWs();
		// 定时刷新时间
		let _this = this;
		// 定时器
		setInterval(() => {
			_this.date = _this.dateFormatToString(new Date()); // 修改数据date
		}, 1000);
		// 定时器刷新，1天
		setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60 * 24);
	},
	beforeDestroy() {
		closeWebsocket1();
		closeWebsocket2();
	},
	methods: {
		wsMessage(data) {
			console.log(data);
			if (data.indexOf('refresh_page') != -1) {
				window.location.reload();
				window.AndroidWebView.refresh();
			} else if (data.indexOf('upgrade_4_' + orgId) != -1) {
				this.$http.get("api/client/new/getUpdateUrl?orgId=" + orgId + "&type=4").then(res => {
					if (res.data.code === 200) {
						console.log(res.data.url);
						window.AndroidWebView.updateApp(res.data.url);
					}
				})
			}
		},
		wsError() {
		},
		requstWs() {
			if (window.location.protocol == 'http:') {
				sendWebsocket2('ws://' + window.location.host + '/otessWd/wsPush.action?objId=upgrade_4_' + orgId + '&objType=data', {}, this.wsMessage, this.wsError)
				sendWebsocket1('ws://' + window.location.host + '/otessWd/wsPush.action?objId=refresh_page&objType=data', {}, this.wsMessage, this.wsError)
			} else {
				sendWebsocket2('wss://' + window.location.host + '/otessWd/wsPush.action?objId=upgrade_4_' + orgId + '&objType=data', {}, this.wsMessage, this.wsError)
				sendWebsocket1('wss://' + window.location.host + '/otessWd/wsPush.action?objId=refresh_page&objType=data', {}, this.wsMessage, this.wsError)
			}
		},
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		initData() {
			let _this = this;
			if (source == 'window') {
				_this.tit_class = 'hm_tit title_letter';
			} else {
				_this.tit_class = 'hm_tit';
			}
		},
		//日期格式化
		dateFormatToString(data) {
			let formatDateTime
			let Y = data.getFullYear()
			let M = data.getMonth() + 1
			let D = data.getDate()
			let H = data.getHours()
			let Min = data.getMinutes()
			let S = data.getSeconds()
			let W = data.getDay()
			H = H < 10 ? ('0' + H) : H
			Min = Min < 10 ? ('0' + Min) : Min
			S = S < 10 ? ('0' + S) : S
			switch (W) {
				case 0:
					W = '天'
					break
				case 1:
					W = '一'
					break
				case 2:
					W = '二'
					break
				case 3:
					W = '三'
					break
				case 4:
					W = '四'
					break
				case 5:
					W = '五'
					break
				case 6:
					W = '六'
					break
				default:
					break
			}
			formatDateTime = Y + '年' + M + '月' + D + '日 ' + H + ':' + Min + ':' + S + ' 星期' + W;
			this.date = formatDateTime;
			return formatDateTime
		},
		//点击全屏
		screen: function () {
			let _this = this;
			let element = document.documentElement;
			if (_this.fullscreen) {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
			} else {
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.msRequestFullscreen) {
					element.msRequestFullscreen();
				}
			}
			_this.fullscreen = !_this.fullscreen;
		}
	},
	// 注意在vue实例销毁前，清除我们的定时器。
	destroyed() {
		if (this.timer) {
			clearInterval(this.timer)
		}
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/headmasterIndex.scss";
#head_index{
	.top_block {
		width: 32.8%;
		height: 38vh;
	}
	
	.left_block,
	.center_block,
	.right_block {
		height: 22vh;
	}
	
	.bottom_block {
		height: 25vh;
	}
	
	.center_block {
		margin: 0 0.22rem;
	}
	
	.title_letter {
		padding-left: 25px;
		letter-spacing: 50px;
	}
}
</style>
